var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button c-button--default c-button--shrinked",on:{"click":_vm.openModal}},[_c('font-awesome-icon',{staticClass:"c-button__left-icon",attrs:{"icon":['far', 'sticky-note']}}),_vm._v("\n    View Instructions\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }